import { BehaviorSubject } from 'rxjs';
import { VtkStlReader } from './vtkStlReader';
// @ts-ignore
import * as vtk from '../lib/vtk.js';

// const { vtk } = require('../../../../../assets/vtk.js');

export abstract class VtkJsReader {
  public static isRendering = new BehaviorSubject<boolean>(true);

  public static loadfile(div: HTMLElement, response: Blob) {
    // this.isRendering = new BehaviorSubject(true);

    const file = new File([response], 'preview.vtkjs');

    this.initLocalFileLoader(div, file);

    return true;
  }

  private static emptyContainer(container: Element) {
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
  }

  private static load(container: Element, options: { file: File }) {
    this.emptyContainer(container);

    const fullScreenRenderer = vtk.Rendering.Misc.vtkFullScreenRenderWindow.newInstance({
      background: [1, 1, 1],
      rootContainer: container,
      containerStyle: {
        height: '80%',
        width: '80%',
        position: 'relative',
        margin: 'auto',
      },
    });

    const renderer = fullScreenRenderer.getRenderer();
    const renderWindow = fullScreenRenderer.getRenderWindow();

    function onReady(sceneImporter: { onReady: (arg0: () => void) => void; resetScene: () => void }) {
      sceneImporter.onReady(() => {
        const actors = renderer.getActors();
        actors.forEach((actor: any) => {
          const property = actor.getProperty();
          property.setColor(0.8, 0.8, 0.8);
        });

        renderWindow.render();
        VtkJsReader.isRendering.next(false);
      });

      window.addEventListener('dblclick', () => {
        sceneImporter.resetScene();
        // renderWindow.render();
      });
    }

    if (options.file) {
      const dataAccessHelper = vtk.IO.Core.DataAccessHelper.get('zip', {
        zipContent: options.file,
        callback: () => {
          const sceneImporter = vtk.IO.Core.vtkHttpSceneLoader.newInstance({
            renderer,
            dataAccessHelper,
          });
          sceneImporter.setUrl('index.json');
          onReady(sceneImporter);
        },
      });
    }
  }

  private static initLocalFileLoader(container: HTMLElement, file: File) {
    const exampleContainer = document.querySelector('.content');
    const rootBody = document.querySelector('body');
    const myContainer = container || exampleContainer || rootBody;

    if (rootBody !== null) {
      if (myContainer !== container) {
        // myContainer.classList.add(style.fullScreen);
        rootBody.style.margin = '0';
        rootBody.style.padding = '0';
      } else {
        rootBody.style.margin = '0';
        rootBody.style.padding = '0';
      }
    }

    const fileContainer = document.createElement('div');
    myContainer.appendChild(fileContainer);

    const fileInput = file;

    this.handleFile(fileInput, myContainer, fileContainer);
  }

  private static handleFile(e: File, myContainer: Element, fileContainer: HTMLElement) {
    myContainer.removeChild(fileContainer);
    this.load(myContainer, { file: e });
  }
}
